import React, { useState, useEffect} from "react";
import { Water } from "./Cards/Water";
import { GreenSpaces } from "./Cards/GreenSpaces";
import { Energy } from "./Cards/Energy";
import { Parking } from "./Cards/Parking";
import { Card, Col, Row, Button } from 'antd';
import { Title } from "./Global/Title";
import { InfoCircleTwoTone, RetweetOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

//["xs","sm","md","lg"]
export const WallboardOne = () => {
    const [buttonIsVisible, setButtonIsVisible] = useState(false);
    let timeout;
    const navigate = useNavigate();

    const showButton = () => {
        if (!buttonIsVisible) setButtonIsVisible(true);
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            setButtonIsVisible(false);
        }, 3000); // Esconde o botão após 3000 milissegundos de inatividade
    };

    useEffect(() => {
        window.addEventListener('mousemove', showButton);
        window.addEventListener('scroll', showButton);
        window.addEventListener('keypress', showButton);

        return () => {
            window.removeEventListener('mousemove', showButton);
            window.removeEventListener('scroll', showButton);
            window.removeEventListener('keypress', showButton);
            clearTimeout(timeout);
        };
    }, [buttonIsVisible]);

    return (
        <div className="site-card-wrapper">
            {buttonIsVisible && (
                <Button type="primary" shape="circle" icon={<RetweetOutlined />}
                    onClick={() => {navigate("/wallboard_two")}}
                    style={{
                        position: 'fixed',
                        right: '20px',
                        top: '20px',
                        zIndex: 1000
                    }} />
            )}
            <Row gutter={16} style={{ padding: '2px 2px 0px 2px', margin: '0', height: '98%' }}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }} style={{ height: '48vh' }}>
                    <Card title={<Title bgTitle='black' style={{ height: '20%' }}>ESTACIONAMENTO</Title>} className='cardDominion' headStyle={{ backgroundColor: 'black', height: '20%' }} bodyStyle={{ display: 'flex', height: '80%', padding: '2px' }}>
                        <Parking />
                    </Card>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }} style={{ height: '48vh' }}>
                    <Card title={<Title bgTitle='#ffc000' style={{ height: '20%' }}>ENERGIA</Title>} className='cardDominion' headStyle={{ backgroundColor: '#ffc000', height: '20%' }} bodyStyle={{ display: 'flex', height: '80%', padding: '2px' }}>
                        <Energy />
                    </Card>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }} style={{ height: '49vh' }}>
                    <Card title={<Title bgTitle='#42b029' style={{ height: '20%' }}>ESPAÇOS VERDES</Title>} className='cardDominion' headStyle={{ backgroundColor: '#42b029', height: '20%' }} bodyStyle={{ display: 'flex', height: '80%', padding: '2px' }}>
                        <GreenSpaces />
                    </Card>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }} style={{ height: '49vh' }}>
                    <Card title={<Title bgTitle='#4472c4' style={{ height: '20%' }}>ÁGUAS</Title>} className='cardDominion' headStyle={{ backgroundColor: '#4472c4', height: '20%' }} bodyStyle={{ display: 'flex', height: '80%', padding: '2px' }}>
                        <Water />
                    </Card>
                </Col>
            </Row>
            <div style={{ height: '2%', fontSize: 'small', fontWeight: 'bold', alignContent: 'baseline', marginLeft: '20px' }}>
                <InfoCircleTwoTone /><span style={{ color: 'black' }}> Dados de Domingo a Sábado</span>
            </div>
        </div>
    )
}